"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getNextAmPmValue;

function getNextAmPmValue(value) {
  if (value === 'AM' || value === undefined) {
    return 'PM';
  }

  return 'AM';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/TimePicker/helpers/getNextAmPmValue.js
// module id = Xw+m
// module chunks = 0